import React from "react";
import Layout from "../common/layouts";
import { graphql, navigate } from "gatsby";
import Seo from "../common/seo";
import { BsPen, BsBook, BsFillPeopleFill, BsSearch } from "react-icons/bs";
import { FaRegNewspaper } from "react-icons/fa";
import "tachyons";

export default class HomeIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      totalNhanSus: 0,
      totalBaiBaos: 0,
      totalSachGiaoTrinhs: 0,
      totalDeTais: 0,
      urlDanhMuc: "/nhakhoahoc",
      generalKey: "",
    };

    this.handleChangeDanhMuc = this.handleChangeDanhMuc.bind(this);
    this.handleChangeKey = this.handleChangeKey.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRedirectToDanhMuc = this.handleRedirectToDanhMuc.bind(this);
  }

  handleRedirectToDanhMuc(danhMuc) {
    switch (danhMuc) {
      case 1:
        navigate("/baibaokhoahoc");
        break;
      case 2:
        navigate("/detaikhoahoc");
        break;
      case 3:
        navigate("/nhakhoahoc");
        break;
      case 4:
        navigate("/giaotrinh");
        break;
      default:
    }
  }

  handleChangeDanhMuc(event) {
    this.setState({
      urlDanhMuc: event.target.value,
    });
  }

  handleChangeKey(event) {
    this.setState({
      generalKey: event.target.value,
    });
  }

  handleClick() {
    navigate(this.state.urlDanhMuc, {
      state: { generalKey: this.state.generalKey },
    });
  }

  componentDidMount() {
    this.setState({
      activeNabar: "bg-red",
    });

    fetch(this.props.data.site.siteMetadata.callApi + "/GetSciences")
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            totalNhanSus: result.totalNhanSus,
            totalBaiBaos: result.totalBaiBaos,
            totalSachGiaoTrinhs: result.totalSachGiaoTrinhs,
            totalDeTais: result.totalDeTais,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  }

  render() {
    const { totalNhanSus, totalBaiBaos, totalSachGiaoTrinhs, totalDeTais } =
      this.state;
    return (
      <Layout activeHome="#f2184f">
        <Seo
          title={"CƠ SỞ DỮ LIỆU KHOA HỌC - TRƯỜNG ĐẠI HỌC QUY NHƠN"}
          titleNhaKhoaHoc={"CSDLKH"}
          description={this.props.data.site.siteMetadata.description}
        />
        <div className="sans-serif">
          <section
            style={{
              backgroundImage: `url(${this.props.data.site.siteMetadata.imageQnu})`,
              // backgroundColor: "rgb(44 56 76)",
              backgroundPosition: "bottom",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              marginTop: "-9px",
            }}
          >
            <div
              className="flex flex-wrap justify-between-ns justify-center w-100 mw9 center-l"
              style={{ padding: "20px 0 0 0" }}
            >
              <div className="flex flex-column">
                <h3
                  className="near-white f5 tracked mb2 db tc"
                  style={{
                    fontSize: "25px",
                  }}
                >
                  CƠ SỞ DỮ LIỆU
                </h3>
                <h2
                  className="f5 tracked mb2 db tc"
                  style={{
                    fontSize: "40px",
                    color: "#f2184f",
                    marginTop: "10px",
                  }}
                >
                  KHOA HỌC <b className="near-white">VÀ</b> CÔNG NGHỆ
                </h2>
                <div
                  className="flex flex-wrap justify-center"
                  style={{ color: "#fa7035" }}
                >
                  <div className="flex flex-column pr4">
                    <div className="flex flex-wrap pointer" role="presentation" onClick={() => this.handleRedirectToDanhMuc(3)}>
                      <div className="flex flex-column pr3 mt3">
                      <BsFillPeopleFill size={50} />
                      </div>
                      <div className="flex flex-column" >
                        <h4>DỮ LIỆU NHÀ KHOA HỌC</h4>
                        <h5
                          style={{ marginTop: "-10px" }}
                          className="mt0 near-white"
                        >
                          {totalNhanSus} Kết Quả
                        </h5>
                      </div>
                    </div>{" "}
                    <div className="flex flex-wrap pointer" role="presentation"  onClick={() => this.handleRedirectToDanhMuc(2)}>
                      <div className="flex flex-column pr3 mt3">
                      <BsPen size={50} />
                      </div>
                      <div className="flex flex-column" >
                        <h4>DỮ LIỆU ĐỀ TÀI - DỰ ÁN - SÁNG KIẾN</h4>
                        <h5
                          style={{ marginTop: "-10px" }}
                          className="mt0 near-white"
                        >
                          {totalDeTais} Kết Quả
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-column">
                    <div className="flex flex-wrap pointer" role="presentation"  onClick={() => this.handleRedirectToDanhMuc(1)}> 
                      <div className="flex flex-column pr3 mt3">
                      <FaRegNewspaper size={50} />
                      </div>
                      <div className="flex flex-column">
                        <h4>DỮ LIỆU BÀI BÁO KHOA HỌC</h4>
                        <h5
                          style={{ marginTop: "-10px" }}
                          className="mt0 near-white "
                        >
                          {totalBaiBaos} Kết Quả
                        </h5>
                      </div>
                    </div>{" "}
                    <div className="flex flex-wrap pointer" onClick={() => this.handleRedirectToDanhMuc(4)} role="presentation" >
                      <div className="flex flex-column pr3 mt3">
                      <BsBook size={50} />
                      </div>
                      <div className="flex flex-column">
                        <h4>DỮ LIỆU SÁCH, GIÁO TRÌNH</h4>
                        <h5
                          style={{ marginTop: "-10px" }}
                          className="mt0 near-white"
                        >
                          {totalSachGiaoTrinhs} Kết Quả
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-column mb4 mt4">
                <div className="pa3 bg-white">
                  <fieldset className="bn">
                    <legend className="fw9 mb2 f5 near-black tc">
                      Tìm kiếm dữ liệu
                    </legend>
                    <div className="mt1">
                      <input
                        className="pa2 input-reset ba w-100 bg-transparent pointer"
                        onKeyPress={(ev) => {
                          if (ev.key === "Enter") {
                            this.handleClick();
                          }
                        }}
                        type="text"
                        value={this.state.generalKey}
                        onChange={this.handleChangeKey}
                        placeholder="Nhập từ khóa..."
                        style={{ borderRadius: "4px" }}
                      ></input>
                    </div>
                    <div className="mt3">
                      <select
                        className="pa2 ba bg-transparent w-100 pointer"
                        onKeyPress={(ev) => {
                          if (ev.key === "Enter") {
                            this.handleClick();
                          }
                        }}
                        value={this.state.urlDanhMuc}
                        onChange={this.handleChangeDanhMuc}
                        onBlur={this.handleChangeDanhMuc}
                        style={{ borderRadius: "4px" }}
                      >
                        <option value="/nhakhoahoc">Nhà khoa học</option>
                        <option value="/baibaokhoahoc">Bài báo khoa học</option>
                        <option value="/detaikhoahoc">Đề tài khoa học</option>
                        <option value="/giaotrinh">Giáo trình</option>
                        <option value="/sachchuyenkhao">
                          Sách chuyên khảo
                        </option>
                      </select>
                    </div>
                    <div className="mt3">
                      <button
                        onKeyPress={(ev) => {
                          if (ev.key === "Enter") {
                            this.handleClick();
                          }
                        }}
                        type="button"
                        onClick={this.handleClick}
                        className="pa2 ba bg-transparent w-100 pointer"
                        style={{ backgroundColor: "#f2184f", color: "white" }}
                      >
                        <BsSearch /> Tìm kiếm
                      </button>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </section>

          <div
            className="flex flex-wrap justify-between w-100 mw9 center mb2 mt2"
            style={{ padding: "0px 10px 0 10px" }}
          >
            <div
              className="flex flex-column w-100 mb1"
              // style={{ maxWidth: "45rem" }}
            >
              <h3
                className="near-black f5 tracked mb0 db"
                style={{ fontSize: "20px" }}
              >
                GIỚI THIỆU TỔNG QUAN VỀ
              </h3>
              <h2
                className="f5 tracked mb4 mt2 db"
                style={{ fontSize: "25px", color: "#f2184f" }}
              >
                TRƯỜNG ĐẠI HỌC QUY NHƠN
              </h2>
              <p className="mt2">
                <span style={{ color: "#548dd4" }}>1. Sứ mệnh</span>
              </p>
              <p className="mt0 lh-copy">
                Trường Đại học Quy Nhơn là cơ sở giáo dục đại học đa ngành, đa
                lĩnh vực có sứ mệnh đào tạo, phát triển nguồn nhân lực chất
                lượng cao; bồi dưỡng nhân tài; nghiên cứu khoa học, truyền bá
                tri thức và chuyển giao công nghệ; phục vụ hiệu quả sự phát
                triển bền vững của đất nước, đặc biệt đối với khu vực Nam Trung
                Bộ - Tây Nguyên; góp phần thúc đẩy tiến bộ xã hội.
              </p>
              <p className="mt1">
                <span style={{ color: "#548dd4" }}>2. Tầm nhìn</span>
              </p>
              <p className="mt0 lh-copy">
                Đến năm 2030, Trường Đại học Quy Nhơn sẽ là trường đại học đa
                ngành, đa lĩnh vực định hướng ứng dụng có uy tín cao, đạt tiêu
                chuẩn chất lượng của khu vực Đông Nam Á; có vị thế quan trọng về
                hợp tác đào tạo, nghiên cứu, trao đổi học thuật, giao lưu văn
                hóa trong nước và quốc tế.
              </p>
              <p className="mt1">
                <span style={{ color: "#548dd4" }}>3. Giá trị cốt lõi</span>
              </p>
              <p className="mt0 lh-copy">
                Trách nhiệm - Chuyên nghiệp - Chất lượng - Sáng tạo - Nhân văn
              </p>
            </div>
            {/* <div className="flex flex-column w-100 mv4" style={{maxWidth: "28rem"}}>
              <img alt="CÁC ĐƠN VỊ KHOA, PHÒNG TRƯỜNG ĐẠI HỌC QUY NHƠN" title="CÁC ĐƠN VỊ KHOA, PHÒNG TRƯỜNG ĐẠI HỌC QUY NHƠN" src={this.props.data.site.siteMetadata.imageQnu2} />
            </div> */}
          </div>
        </div>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        siteTitle: title
        description
        imageQnu
        imageQnu2
        siteUrl
        callApi
      }
    }
  }
`;
